<template lang="html">
    <div class="loading-box" v-if="showLoading">
        <a-spin tip="Loading..."></a-spin>
    </div>
</template>
<script>
    export default {
        name:'Loading',
        data() {
            return {

            }
        },
        props: {
            showLoading: false,
        }
    }
</script>
<style lang="less">
    .loading-box{
        background: rgba(255,255,255,.9);
        position: fixed;
        left:0;
        bottom:0;
        right:0;
        top:0;
        z-index: 9000000;
        .ant-spin{
            width:100px;
            height:46px;
            position: absolute;
            left:50%;
            margin-left:-50px;
            top:50%;
            margin-top:-23px;
        }
    }
</style>
